import type { GetClassRoomResponse } from "@/openapi/generated/models";

function pickClassroomDescriptionRaw(
  classroom: GetClassRoomResponse | Record<string, unknown>,
): unknown {
  const c = classroom as Record<string, unknown>;
  return (
    c.description ??
    c.Description ??
    c.roomDescription ??
    c.RoomDescription
  );
}

function trimNonEmpty(value: unknown): string | null {
  if (value == null) return null;
  const s = String(value).trim();
  return s.length > 0 ? s : null;
}

/**
 * Public modal / class page: description for the "space".
 * Many APIs omit `description` on the class-room root and only send it on nested `location`
 * (same text as the location page - see e.g. class-rooms responses on the API).
 */
export function getClassroomOptionalDescription(
  classroom: GetClassRoomResponse | null | undefined,
): string | null {
  if (!classroom) return null;

  const fromRoom = trimNonEmpty(pickClassroomDescriptionRaw(classroom));
  if (fromRoom) return fromRoom;

  const loc = classroom.location;
  if (!loc) return null;
  const locAsJson = loc as unknown as Record<string, unknown>;
  const fromLocation = trimNonEmpty(loc.description ?? locAsJson.Description);
  return fromLocation;
}
